import * as React from 'react';
import appleSelected from '../../../assets/apple-selected.svg';
import appleUnselected from '../../../assets/apple-unselected.svg';
import appleDisabledSelected from '../../../assets/apple-disabled-selected.svg';
import appleDisabledUnselected from '../../../assets/apple-disabled-unselected.svg';
import { IconProps } from '../../typescriptHelpers';

interface AppleAppIconProps extends IconProps {
    isSelected: boolean;
    isDisabledTreatment: boolean;
}

const AppleAppIcon: React.FC<AppleAppIconProps> = (props: AppleAppIconProps) => {
    let sourceImage = props.isSelected ? appleSelected : appleUnselected;
    if (props.isDisabledTreatment) {
        sourceImage = props.isSelected ? appleDisabledSelected : appleDisabledUnselected;
    }

    return <img src={sourceImage} width={props.width} height={props.height} />;
};

export default AppleAppIcon;
